import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable, forkJoin, map } from 'rxjs';

import { MagnetService } from '@mirage-projects/cw-commons';
import { ObjectHelperService } from '@mirage-projects/cw-utils';

export class CustomLoader implements TranslateLoader {
    constructor(
        private http: HttpClient,
        private magnetService: MagnetService,
        private location: Location,
        private objectHelperService: ObjectHelperService
    ) {}

    /**
     * Loads the app's resources
     * @param langCountry Country to load the resources from
     * @returns
     */
    getTranslation(langCountry: string): Observable<any> {
        if (this.magnetService.isConnectingFromMagnet()) {
            return this.getTranslationCW(langCountry);
        }

        return this.getTranslationCRE(langCountry);
    }

    /**
     * Loads the common resources
     * @param langCountry Country to load the resources from
     * @returns
     */
    private getTranslationCW(langCountry: string): Observable<any> {
        return this.http.get(`assets/i18n/collage-${langCountry}.json`);
    }

    /**
     * Loads the common resources and the CRE ones
     * @param langCountry Country to load the resources from
     * @returns
     */
    private getTranslationCRE(langCountry: string): Observable<any> {
        const creUrl = this.location.prepareExternalUrl(`assets/i18n/cre-${langCountry}.json`);

        return forkJoin([this.getTranslationCW(langCountry), this.http.get(creUrl)]).pipe(
            map(([translationCW, translationCRE]) => {
                return this.objectHelperService.deepObjectMerge(translationCW, translationCRE);
            })
        );
    }
}
